import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class Variables extends AbstractController {
    protected controllerName = 'Variables';
}
